import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage({ onSuccess }) {
  const { login, loginError, loading } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    const ok = await login(username, password);
    if (ok && onSuccess) onSuccess();
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo">
          <img src="/ms-logo.jpg" alt="Math&amp;Sport" className="login-logo-img" />
        </div>
        <h1 className="login-title" style={{textAlign:'center'}}>Portal</h1>
        <p className="login-subtitle" style={{textAlign:'center'}}>Workspace Web Interattivo</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="field-group">
            <label className="field-label" htmlFor="username">Username</label>
            <input
              id="username"
              className="field-input"
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="mathandsport"
              autoComplete="username"
              required
            />
          </div>
          <div className="field-group">
            <label className="field-label" htmlFor="password">Password</label>
            <input
              id="password"
              className="field-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          {loginError && (
            <div className="login-error" role="alert">
              ⚠ {loginError}
            </div>
          )}

          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'Accesso in corso…' : 'Accedi'}
          </button>
        </form>

        <p className="login-note">
          Accesso riservato al personale Math&amp;Sport.
        </p>
      </div>
    </div>
  );
}
